/* import __COLOCATED_TEMPLATE__ from './empty-subscription-types-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();